import React, { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import SideBar from "../navigation/sidebar/SideBar";
import NavBar from "../navigation/topnav/NavBar";
import RowTitles from "../components/RowTitles";
import Loader from "../gif/loader.gif";
import axios from "axios";
import { useParams } from "react-router-dom";
import { RiBarChartHorizontalLine } from "react-icons/ri";
import { FaFemale } from "react-icons/fa";
import { FaMale } from "react-icons/fa";
import { MdOutlineQueryStats } from "react-icons/md";
import { VscPercentage } from "react-icons/vsc";
import { IoCalendarNumberOutline } from "react-icons/io5";
import AttandanceListComp from "../components/AttandanceListComp";
import { IoCloseOutline } from "react-icons/io5";
import { PiUsersBold } from "react-icons/pi";
import { FiSearch } from "react-icons/fi";

const AttandanceList = () => {
  //
  const { param } = useParams();
  //states
  const [loading, setLoading] = useState(false);
  const [attandance, setAttandance] = useState([]);
  const [bunkers, setBunkers] = useState([]);
  //
  const [attandanceTemp, setAttandanceTemp] = useState([]);
  const [bunkersTemp, setBunkersTemp] = useState([]);
  //
  const [maleTotal, setMaleTotal] = useState(0);
  const [femaleTotal, setFemaleTotal] = useState(0);
  //
  const [attandanceSearchKeyword, setAttandanceSearchKeyword] = useState();
  const [bunkersSearchKeyword, setBunkersSearchKeyword] = useState();

  const getList = async () => {
    setLoading(true);
    let att = [];
    let bunk = [];
    let male = 0;
    let female = 0;
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-list?title=${param}`
      );
      let retcode = res.data;
      retcode.forEach((item) => {
        if (item.attendance_status === "Attended") {
          att.push(item);
          if (item.gender === "Female") {
            male++;
          } else {
            female++;
          }
        } else {
          bunk.push(item);
        }
      });
      setAttandance(att);
      setBunkers(bunk);
      //set temporary storage
      setAttandanceTemp(att);
      setBunkersTemp(bunk);
      //
      setMaleTotal(male);
      setFemaleTotal(female);
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("get attandance list error =>" + error);
    }
  };
  const searchAttandeeItem = () => {
    const processedName = attandanceSearchKeyword.toLowerCase();

    const filteredData = attandance.filter(
      (item) =>
        item.name.toLowerCase() === processedName ||
        item.cell.toLowerCase()() === processedName ||
        item.surname.toLowerCase()() === processedName
    );
    setAttandance(filteredData);
  };
  const searchBunkersItem = () => {
    const processedName = bunkersSearchKeyword.toLowerCase();

    const filteredData = attandance.filter(
      (item) =>
        item.name.toLowerCase().includes(processedName) ||
        item.cell.toLowerCase().includes(processedName) ||
        item.surname.toLowerCase().includes(processedName)
    );
    setBunkers(filteredData);
  };
  const resetAttandance = () => {
    setAttandanceSearchKeyword("");
    setAttandance(attandanceTemp);
  };
  const resetABunkers = () => {
    setBunkersSearchKeyword("");
    setBunkers(bunkersTemp);
  };
  useEffect(() => {
    getList();
  }, []);
  return (
    <div className="d-flex" style={{ backgroundColor: "#f1f5f7" }}>
      <SideBar />
      {/* Main Content */}
      <div className="flex-grow-1">
        <NavBar />
        <div className="container-fluid mt-4">
          <div className="row">
            {/* Cards */}
            <div className="col-md-3">
              <div
                className="p-3 mb-4 text-secondary shadow"
                style={{
                  backgroundColor: "#fff",
                  color: "white",
                  borderRadius: 15,
                }}
              >
                <div className="row">
                  <div className="col-10 mb-3">
                    <div className="row">
                      <div className="col-md-6">
                        <small style={{ fontSize: 14 }}>Attandees</small>{" "}
                      </div>
                      <div className="col-md-6">
                        <small style={{ fontSize: 14 }}>Bunkers</small>{" "}
                      </div>
                    </div>
                  </div>
                  <div className="col-2">
                    <RiBarChartHorizontalLine
                      size={28}
                      style={{ color: "#33afe0" }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-5">
                    <h4 style={{ marginTop: "-10px", color: "#3bc0c3" }}>
                      {attandance.length}
                    </h4>
                  </div>
                  <div className="col-md-6">
                    <h4 style={{ marginTop: "-10px", color: "#33afe0" }}>
                      {"   "}
                      {bunkers.length}
                    </h4>
                  </div>
                </div>
                <div className="w-25" />
              </div>
            </div>
            <div className="col-md-3">
              <div
                className="p-3 mb-4 text-secondary shadow"
                style={{
                  backgroundColor: "#fff",
                  color: "white",
                  borderRadius: 15,
                }}
              >
                <div className="row">
                  <div className="col-10 mb-3">
                    <small style={{ fontSize: 14 }}>Gender demographics</small>{" "}
                  </div>
                  <div className="col-2">
                    <MdOutlineQueryStats
                      size={28}
                      style={{ color: "#716caf" }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-2 m-0">
                    <FaFemale size={28} style={{ color: "#3bc0c3" }} />
                  </div>
                  <div className="col-md-2 m-0 text-start">
                    <small>{femaleTotal}</small>
                  </div>
                  <div className="col-md-4 p-0 m-0">
                    <ProgressBar
                      variant="info"
                      style={{ marginTop: 5 }}
                      now={(femaleTotal / attandance.length) * 100}
                      label={`${(femaleTotal / attandance.length) * 100}%`}
                    />
                  </div>
                  <div className="col-md-2 text-right">
                    <small>{maleTotal}</small>
                  </div>
                  <div className="col-md-2">
                    <FaMale size={28} style={{ color: "#33afe0" }} />
                  </div>
                </div>
                <div className="w-25" />
              </div>
            </div>
            <div className="col-md-3">
              <div
                className="p-3 mb-4 text-secondary shadow"
                style={{
                  backgroundColor: "#fff",
                  color: "white",
                  borderRadius: 15,
                }}
              >
                <div className="row">
                  <div className="col-10 mb-3">
                    <small style={{ fontSize: 14 }}>Attandance rate</small>{" "}
                  </div>
                  <div className="col-2">
                    <VscPercentage size={27} style={{ color: "#3bc0c3" }} />
                  </div>
                </div>
                <h4 style={{ marginTop: "-10px", color: "#3bc0c3" }}>
                  {((attandance.length / bunkers.length) * 100).toFixed(2)}%
                </h4>
              </div>
            </div>
            <div className="col-md-3">
              <div
                className="p-3 mb-4 text-secondary shadow"
                style={{
                  backgroundColor: "#fff",
                  color: "white",
                  borderRadius: 15,
                }}
              >
                <div className="row">
                  <div className="col-9 mb-3">
                    <small style={{ fontSize: 14 }}>Event name</small>{" "}
                  </div>
                  <div className="col-3">
                    <IoCalendarNumberOutline
                      size={28}
                      style={{ color: "#33afe0" }}
                    />
                  </div>
                </div>
                <h5 style={{ marginTop: "-10px", color: "#33afe0" }}>
                  {param}
                </h5>
              </div>
            </div>
          </div>
          <RowTitles title={"Dashboad"} child={"Attandees list"} />
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-12">
                    <div className="input-group col-md-3 mb-3">
                      <span className="input-group-append ml-3">
                        <div className="btn btn-outline-secondary py-2 border-left-0 border text-info">
                          <PiUsersBold className="me-2 text-info" />
                          {attandance.length}
                        </div>
                      </span>
                      <input
                        className="form-control py-2 border-right-0 border"
                        placeholder="search by member name, cell, surname"
                        style={{ fontStyle: "italic" }}
                        onChange={(e) =>
                          setAttandanceSearchKeyword(e.target.value)
                        }
                      />
                      <span
                        className="input-group-append bg-info mr-1"
                        onClick={searchAttandeeItem}
                      >
                        <div className="btn py-2 rounded">
                          <FiSearch style={{ color: "white" }} />
                        </div>
                      </span>
                      <span
                        className="input-group-append ml-3"
                        onClick={resetAttandance}
                      >
                        <div className="btn btn-outline-secondary py-2  border-left-0 border">
                          <IoCloseOutline />
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
                {loading ? (
                  <img src={Loader} alt="QR Code" width={"50"} height={"50"} />
                ) : (
                  <AttandanceListComp
                    members={attandance && attandance}
                    eventname={param}
                    itemsPerPage={20}
                  />
                )}
              </div>
              <div className="col-md-6">
                <div className="col-md-12">
                  <div className="input-group col-md-3 mb-3">
                    <span className="input-group-append ml-3">
                      <div className="btn btn-outline-secondary py-2 border-left-0 border text-warning">
                        <PiUsersBold className="me-2 text-warning" />
                        {bunkers.length}
                      </div>
                    </span>
                    <input
                      className="form-control py-2 border-right-0 border"
                      placeholder="search by member name, cell or surname"
                      style={{ fontStyle: "italic" }}
                      onChange={(e) => setBunkersSearchKeyword(e.target.value)}
                    />
                    <span
                      className="input-group-append bg-warning mr-1"
                      onClick={searchBunkersItem}
                    >
                      <div className="btn py-2 rounded">
                        <FiSearch style={{ color: "white" }} />
                      </div>
                    </span>
                    <span
                      className="input-group-append ml-3"
                      onClick={resetABunkers}
                    >
                      <div className="btn btn-outline-secondary py-2  border-left-0 border">
                        <IoCloseOutline />
                      </div>
                    </span>
                  </div>
                </div>
                {loading ? (
                  <img src={Loader} alt="QR Code" width={"50"} height={"50"} />
                ) : (
                  <AttandanceListComp
                    members={bunkers && bunkers}
                    itemsPerPage={20}
                    eventname={param}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttandanceList;
